<template>
  <div>
    <el-dialog
        title="Khởi tạo hóa đơn"
        :visible.sync="isOpenInitializeOrderKidsExcelDialog"
        width="900px"
        :before-close="handleClose"
        :close-on-click-modal="false"
    >
      <el-row class="overwrite">
        <el-col :span="9">
          <div>
            <el-checkbox
                v-model="overwritePayment"
            >Cho phép ghi đè khoản thu
            </el-checkbox>
          </div>
        </el-col>
        <el-col :span="7">
          <div>
            <el-checkbox v-model="overwriteNote"
            >Cho phép ghi đè ghi chú
            </el-checkbox>
          </div>
        </el-col>
      </el-row>


      <el-row class="overwrite"  style="margin-top: 25px">
        <el-col :span="9">
          <el-checkbox style="color: black" v-model="checkCreateMoney" @change="changeCreateMoney">Thêm mới tiền đã thu
            (Lần đầu)
          </el-checkbox>
        </el-col>
        <el-col :span="8">
          <el-checkbox style="color: black" v-model="checkUpdateMoney" @change="changeUpdateMoney">Cập nhật tiền đã
            thu
          </el-checkbox>

          <el-row v-if="updateMoney==='UPDATE_MONEY'" style="margin-top: 15px">
            <el-col>
              <el-radio-group v-model="statusTransactionEntry">
                <el-radio style="color: black" label="MONEY_WALLET">Không chuyển</el-radio>
                <el-radio style="color: black" label="MONEY_MONTH">Sang tháng sau</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col :offset="18" :span="8" style="margin-top: 20px">
          <el-button type="primary" @click="submitImport" :loading="loadingImport">Khởi tạo <i
              class="el-icon-upload el-icon-right"></i></el-button>
          <el-button type="danger" @click="handleClose"
          ><i class="el-icon-circle-close"/> Đóng
          </el-button>
        </el-col>
      </el-row>

    </el-dialog>
  </div>


</template>
<script>

import revenueManagementService from "@/services/Finance_Kids_V2/RevenueManagementService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "InitializeOrderKidsExcelDialog",
  emits: {},
  props: {
    isOpenInitializeOrderKidsExcelDialog: {
      type: Boolean,
      default: () => false,
    },
    listIdOrder: {
      type: Array,
      default: () => [],
    },
    listKidCode: {
      type: Array,
      default: () => [],
    },
    dataSearch: {
      type: Object,
      default: () => null
    },
    type: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      pickerStartDateOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        },
      },

      pickerEndDateOptions: {
        disabledDate: (time) => {
          const startDate = new Date(this.startDate);
          return time.getTime() <= startDate.getTime();
        },
      },
      pickerOptions: {
        shortcuts: [{
          text: 'Tuần trước',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Tháng trước',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '3 Tháng trước',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        },
          {
            text: '6 Tháng trước',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit('pick', [start, end]);
            }
          },]
      },
      monthAndYearUpload: "",
      loadingImport: false,
      startDateExcel: null,
      endDateExcel: null,
      value1: '',
      listDay: [],
      textTable: this.$tableEmpty,
      excelFile: null,
      turn: null,
      collectionTurn: null,

      listError: [],
      listConfirm: [],
      multipleSelection: [],
      checkCreateMoney: true,
      checkUpdateMoney: false,
      /**
       * Dữ liêu thông báo thông tin
       */
      checkKidCode: "",
      checkStructureTable: "",
      checkInformation: "",
      checkAttendance: "",
      checkPayment: "",
      checkMoney: "",
      checkRegisterPackage: false,

      fileList: [],
      showUploadButton: false,
      isContinue: true,
      /**
       * Dữ liêu ghi đè khi lưu vào DB
       */
      overwriteAttendance: false,
      overwritePayment: true,
      overwriteMoney: true,
      overwriteNote: true,
      statusTransactionEntry: "MONEY_WALLET",
      updateMoney: "CREATE_MONEY",

      dataReturn: "",
      dialogFormVisible: false,
      dialogFailInformation: false,
      isInputDescriptionTurn: false,
      month: "",
      year: "",
      classNameCurrent: "",
      gradeNameCurrent: "",
      /**
       * Dữ liệu trong Form tạo đợt thu mới
       */
      form: {
        descriptionTurn: "",
        collectionTurn: 1
      },
      saveExcelParams: [],

      startDate: null,
      endDate: null,
      idPackage: null,
      packages: [],
    };
  },

  watch: {
    "startDate"(newValue) {
      if (newValue === null) {
        this.handleClearEndDate();
      }
    }
  },
  methods: {
    handleClearEndDate() {
      this.endDate = "";
    },

    changeUpdateMoney() {
      this.checkCreateMoney = false
      if (this.checkUpdateMoney === true) {
        this.updateMoney = 'UPDATE_MONEY'
      } else {
        this.checkCreateMoney = true
        this.updateMoney = 'CREATE_MONEY'
      }
      this.statusTransactionEntry = 'MONEY_WALLET'
    },
    changeCreateMoney() {
      this.checkUpdateMoney = false
      if (this.checkCreateMoney === true) {
        this.updateMoney = 'CREATE_MONEY'
      } else {
        this.checkUpdateMoney = true;
        this.updateMoney = 'UPDATE_MONEY'
      }
      this.statusTransactionEntry = 'MONEY_WALLET'
    },

    /**
     * Nhấn nút Import, lưu dữ liệu vào DB
     */
    async handleClickImportButton() {
      // this.loadingImport = true
      this.saveExcelParams = []

      this.$props.listKidCode.forEach((x) => {
        let param = {
          kidCode: String,
          month: Number,
          year: Number,
          statusSaveAttendance: Boolean,
          statusSavePayment: Boolean,
          statusSaveMoney: Boolean,
          statusSaveNote: Boolean,
          statusTransactionEntry: String,
          statusAddMoneyFirst: String,
          idGrade: Number,
          idClass: Number,
          startDate: String,
          endDate: String,
          idListPackage: Number,
        }
          param.kidCode = x;
          param.month = this.dataSearch.month;
          param.year = this.dataSearch.createdYear;
          param.statusSaveAttendance = this.overwriteAttendance;
          param.statusSavePayment = this.overwritePayment;
          param.statusSaveMoney = this.overwriteMoney;
          param.statusSaveNote = this.overwriteNote;
          param.statusTransactionEntry = this.statusTransactionEntry;
          param.statusAddMoneyFirst = this.updateMoney;
          param.idClass = this.dataSearch.idClass;
          param.idGrade = this.dataSearch.idGrade;
          param.idListPackage = this.idPackage;
          param.startDate = this.startDate;
          param.endDate = this.endDate;
          this.saveExcelParams.push(param)
      });
      let data = {
        saveExcelParams: this.saveExcelParams,
        listIdOrder: this.$props.listIdOrder,
        idGroup: this.$props.dataSearch.idGroup
      }
      if (this.$props.type === "CLASS") {
        revenueManagementService.initializeOrderKidsExcelNew(data).then(() => {
          NotifyMessage.leftCornerNotificationSuccess("Khởi tạo thành công!")
        }).catch(err => {
          console.log(err)
          NotifyMessage.leftCornerNotificationError("Khởi tạo thất bại")
        })
      } else {
        revenueManagementService.initializeOrderKidsExcelNewForGroup(data).then(() => {
          NotifyMessage.leftCornerNotificationSuccess("Khởi tạo thành công!")
        }).catch(err => {
          console.log(err)
          NotifyMessage.leftCornerNotificationError("Khởi tạo thất bại")
        })
      }
      this.handleClose()
    },

    submitImport() {
      this.handleClickImportButton();
    },

    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: semi-bold;";
    },
    handleClose() {
      this.monthAndYearUpload = "";
      this.overwriteNote = true;
      this.overwriteAttendance = true;
      this.overwritePayment = true;
      this.overwriteMoney = true;
      this.multipleSelection = [];
      this.listDay = [];
      this.isInputDescriptionTurn = false;
      this.form.descriptionTurn = "";
      this.turn = null;
      this.showUploadButton = false;
      this.listError = [];
      this.listConfirm = [];
      this.dialogFormVisible = false;
      this.dialogFailInformation = false;
      this.checkCreateMoney = true;
      this.checkUpdateMoney = false;
      this.checkRegisterPackage = false;
      this.resetDataDateTime();
      this.updateMoney = "CREATE_MONEY"
      this.statusTransactionEntry = "MONEY_WALLET"
      this.$emit("close");
    },


    resetDataDateTime() {
      this.startDate = null;
      this.endDate = null;
      this.idPackage = null;
    },

  },
};


</script>
<style lang="scss" scoped>
.button_method {
  text-align: left;
}

.input-common {
  margin-right: 5px;
}

.excel-upload-input {
  display: none;
}

.overwrite {
  margin-top: 5px;
}

.excel_upload {
  float: left;
  margin-right: 10px;
}

/deep/ .el-form-item__label {
  text-align: left;
}

.custom_button {
  display: flex;
  justify-content: right;
  margin-right: 10px;
  margin-top: 10px;
}

.custom_button_error {
  display: flex;
  justify-content: right;
  margin-top: 20px;
}

.block {
  /deep/.el-input__inner {
    border: 1px solid #F56C6C;
    border-radius: 4px;
  }
}

.message-err {
  color: #F56C6C;
  margin-top: 6px;
  font-size: 11px;
}
</style>
